// import Swiper core and required modules
import { Navigation, Lazy, A11y } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
  name: 'delDiaProcess',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Navigation, A11y, Lazy],
    };
  },
};
